import React from 'react';
import VideoItem from "../../Home/VideoItem";
import PremieredVideoItem from '../../Home/PremieredVideoItem';
import { validateExpirationDate } from '../../../utils/handlePremiereDates';


const RecentPage = ({ payload, setFile, color }) => {
 let today = new Date()
 
  return payload['recent']
    .sort((a, b) => {
      return (
        (b.switches.date.selected === "original date"
          ? new Date(b.original_date).getTime()
          : new Date(b.date).getTime()) -
        (a.switches.date.selected === "original date"
          ? new Date(a.original_date).getTime()
          : new Date(a.date).getTime())
      );
    })
    .map(videoObj => {
      if (validateExpirationDate(videoObj?.premiereDate)) {
        return <PremieredVideoItem videoObj={videoObj}/>
      } else {
        return (
          <VideoItem
            key={videoObj._id}
            item={videoObj}
            color={color}
            onClick={() => setFile(videoObj, [], "vid")}
          />
        );
      }
     
    });

   
}

export default RecentPage;